import React from 'react'
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"

const AddressMap = (props) => {
  const {
    zoom,
    coords
  } = props

  return (
    <GoogleMap
      defaultZoom={ zoom || 16 }
      center={{ lat: coords.lat, lng: coords.lng }} >
      <Marker position={{ lat: coords.lat, lng: coords.lng }} />
    </GoogleMap>
  )
}

export default withScriptjs(withGoogleMap(AddressMap))
